import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { DomParser } from "../utils/dom-parser";
import { WidgetBox, Empty, Action } from "../components";
import classNames from "classnames";

const YourInbox = ({ title = "Your Inbox" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[sp-root='YourInbox'] > tbody > tr > td"
        );
        const columns = domParser.columns;
        const cols = [];

        columns.forEach(o => {
            cols.push({
                link: domParser.singleAnchor(o),
                text: domParser.textSpan(o)
            });
        });

        return cols;
    };

    const data = parseDataFromDOM();

    const listClasses = classNames("v-list", {
        "v-list--overflow": data.length > 3
    });

    const externalLinkContainerClasses = classNames(
        "external-link-container external-link-container--top",
        {
            "external-link-container--overflow": data.length > 300
        }
    );

    return (
        <WidgetBox title={title} icon="envelope" noPadding>
            <Scrollbars
                autoHide
                autoHeight
                autoHeightMin={0}
                autoHeightMax={300}
            >
                <div className={listClasses}>
                    <div style={{ margin: "0px 45px" }}>
                        <Empty isEmpty={data.length === 0} />
                    </div>
                    {data.map((o, i) => (
                        <div
                            key={i}
                            className="v-list-item v-list-item--alternate"
                        >
                            <Action classes="v-list-item__title" {...o.link} />
                            {o.text.split("\n").map((t, ti) => (
                                <p key={ti}>{t}</p>
                            ))}
                        </div>
                    ))}
                </div>
            </Scrollbars>
            <div className={externalLinkContainerClasses}></div>
        </WidgetBox>
    );
};

export default YourInbox;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/your-inbox.js